// extracted by mini-css-extract-plugin
module.exports = {"loadingHeader":"WidgetLoader_loadingHeader__pZiT0","loading":"WidgetLoader_loading__1ve7B"};